export const legacyDateInputToIsoString = (props?: {
    // date as iso string
    date?: string;
    // hour modifier
    hour?: number;
    // minute modifier
    min?: number;
}) => {
    if (!props?.date) {
        return undefined;
    }
    const date = new Date(props.date);
    date.setHours(props.hour ?? 0);
    date.setMinutes(props.min ?? 0);
    return date.toISOString();
};
